import React, { useEffect, useState } from 'react';
import { Clear } from '@youlify/icons';
import classNames from 'classnames';

import { useChipsStyle } from '../style/chips-trigger';
import { ChipsProps } from '../types';

const Chips: React.FC<ChipsProps> = ({
  label,
  checked = false,
  disabled = false,
  closable = false,
  labelStyle,
  style,
  onClose,
  onChange,
  icon,
  size,
}) => {
  const [isSelected, setIsSelected] = useState(checked);
  const [isPressed, setIsPressed] = useState(false);
  const [visible, setVisible] = useState(true);
  const prefixCls = 'youlify-chips';

  const [wrapSSR, hashId] = useChipsStyle('youlify-chips');

  const cls = classNames(prefixCls, hashId, {
    [`${prefixCls}-selected`]: isSelected,
    [`${prefixCls}-disabled`]: disabled,
    [`${prefixCls}-pressed`]: isPressed,
    [`${prefixCls}-large`]: size === 'large',
  });

  const handleClick = () => {
    if (disabled) return;
    const next = !isSelected;
    setIsSelected(next);
    onChange?.(next);
  };

  const handleClose = (e: React.MouseEvent) => {
    if (disabled) return;
    e.stopPropagation();
    setVisible(false);
    onClose?.();
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks-extra/no-direct-set-state-in-use-effect
    setIsSelected(checked);
  }, [checked]);

  if (!visible) return null;

  return wrapSSR(
    <div
      className={cls}
      style={style}
      onClick={handleClick}
      onMouseDown={() => !disabled && setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onMouseLeave={() => setIsPressed(false)}
    >
      {icon && <div className={`${prefixCls}-icon`}>{icon}</div>}
      <div className={`${prefixCls}-label`} style={labelStyle}>
        {label}
      </div>
      {closable && !disabled && (
        <div className={`${prefixCls}-close`} onClick={handleClose}>
          <Clear className={`${prefixCls}-close-icon`} />
        </div>
      )}
    </div>,
  );
};

export default Chips;
